import factory from '../../../store/factory'

export default {
  partners: factory('Partners'),
  partner_documents: factory('PartnerDocument'),
  partner_notes: factory('PartnerNotes'),
  partner_status_history: factory('PartnerStatusHistory'),
  partner_statement: factory('PartnerStatement'),
}